export default "__VITE_ASSET__VY1NvFE3__"